var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticStyle:{"padding":"0% 1% 0% 1%"}},[_c('v-col',{staticStyle:{"background":"gray"},attrs:{"cols":"12"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }